import { Button as ChakraButton } from "@chakra-ui/react";

const Button = ({ children, disabled, ...rest }) => {
  return (
    <ChakraButton
      minW="150px"
      borderRadius="50px"
      color="white"
      bg="#03A438"
      border="none"
      textTransform="capitalize"
      transition="all 300ms ease-in-out"
      p="10px 20px"
      disabled={disabled}
      cursor={disabled ? "not-allowed" : "pointer"}
      _hover={{
        cursor: disabled ? "not-allowed !important" : "pointer",
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _focus={{
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _active={{
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _disabled={{
        opacity: 0.4,
        pointerEvents: "none",
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  );
};

export default Button;
